module.exports = __webpack_public_path__ + "img/icono_speaker.fc0edb43.svg";